import React from 'react';
import PropTypes from 'prop-types';
import {
  LeftColumnSection,
  LinksColumnSection,
  detailsFooterContentParser
} from '../componentSections/detailsFooterComponents';
import { fireDetailsPageComponentFailureFpti } from '../../../lib/helpers';

const DetailsFooter = ({
  componentContent,
  handleClickFPTI,
  fptiImpression,
  toolName
}) => {
  if (!componentContent) {
    return null;
  }

  const { links, title, subtitle, subtitleLink } = componentContent;
  let buffSubLinkData = {};

  if (!links || !title) {
    fireDetailsPageComponentFailureFpti({
      data: { links, title },
      componentName: 'DetailsFooter',
      fptiImpression
    });
    return null;
  }

  try {
    buffSubLinkData = JSON.parse(subtitleLink);
  } catch (error) {
    buffSubLinkData = {};
  }

  const linkItemValuesPair = links ? detailsFooterContentParser(links) : [];

  return (
    <div id="details-footer-solution">
      <div className="details-footer-container">
        <LeftColumnSection
          questionsLabel={title}
          helpLabel={subtitle}
          handleClickFPTI={handleClickFPTI}
          subtitleLink={buffSubLinkData}
        />
        {linkItemValuesPair.length > 0 &&
          linkItemValuesPair.map((item, index) => (
            <LinksColumnSection
              key={`details-footer-item${index}`}
              linkItems={item}
              handleClickFPTI={handleClickFPTI}
              toolName={toolName}
            />
          ))}
      </div>
    </div>
  );
};

DetailsFooter.propTypes = {
  componentContent: PropTypes.object,
  handleClickFPTI: PropTypes.func,
  fptiImpression: PropTypes.func.isRequired,
  toolName: PropTypes.string
};

export default DetailsFooter;
